<template>
  <div class="lee-platform-container">
    <el-tabs v-model="active" type="card">
      <el-tab-pane label="抖音号" name="douyin">
        <lee-tiktok />
      </el-tab-pane>
      <el-tab-pane label="快手号" name="kuaishou">
        <lee-kuaishou />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import LeeTiktok from "./tiktok.vue";
import LeeKuaishou from "./kuaishou.vue";
export default {
  components: {
    LeeTiktok,
    LeeKuaishou,
  },
  data() {
    return {
      active: "douyin",
    };
  },
};
</script>
<style lang="less" scoped>
.lee-platform-container {
  background: #fff;
  padding: 24px;
}
</style>
